/** tempexp_14728-full-file */
import React, { FC } from 'react';

import { IncomingItemProps } from '../../DataListItemRow.types';
import { Access } from '../Access/Access';
import { Checkbox } from '../Checkbox/Checkbox';
import { Destination } from '../Destination/Destination';
import { Invitation } from '../Invitation/Invitation';
import { ItemName } from '../ItemName/ItemName';
import { Pic } from '../Pic/Pic';
import { Publish } from '../Publish/Publish';
import { Size } from '../Size/Size';
import { TableColumn } from '../TableColumn/TableColumn';

interface IncomingProps extends IncomingItemProps {
    checkboxClassname?: string;
}

export const Incoming: FC<IncomingProps> = (props) => {
    return (
        <>
            <TableColumn>
                <Checkbox className={props.checkboxClassname} onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} />
                <Pic isFolder={true} kind={props.kind} author={props.owner} />
            </TableColumn>
            <TableColumn width="100%" overflow="hidden">
                <ItemName name={props.name} />
            </TableColumn>
            <TableColumn minWidth={220} width="100%">
                <Destination destination={props.owner.name} author={props.owner} />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="flex-end">
                <Access access={props.access} />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="center">
                <Size size={props.size} />
            </TableColumn>
            <TableColumn flexBasis={128} flexShrink={0} justifyContent="flex-end" gap={20}>
                {props.isMounted ? (
                    <Publish onClick={props.onMount} isShared={true} />
                ) : (
                    <Invitation onAccept={props.onAccept} onReject={props.onReject} />
                )}
            </TableColumn>
        </>
    );
};
